import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import useDraft from "./hooks/useDraft";
import ApprovalModal from "./components/ApprovalModal";
import ProductsTable from "./components/ProductsTable";
import OrderSummaryPanel from "./components/OrderSummaryPanel";
import { ToastContainer } from "react-toastify";
import { useUserTheme } from "src/shared/hooks/useUserTheme";
import CommonButtons from "src/shared/components/CommonButtons";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";

function DraftDetails() {
  const { draftId } = useParams();
  const navigate = useNavigate();
  const { sidebarThemeClass } = useUserTheme();
  const { draft, loading, error, updatesLedgerLimit, closePopup, setClosePopup, draftStatusUpdate } = useDraft(draftId);

  if (loading) return <div className="min-h-screen bg-[#EEF1FB] p-6 text-sm text-[#5B6472]">Loading draft…</div>;
  if (error) return <div className="min-h-screen bg-[#EEF1FB] p-6 text-sm text-[#B3261E]">Something went wrong loading this draft.</div>;
  if (!draft) return <div className="min-h-screen bg-[#EEF1FB] p-6 text-sm text-[#5B6472]">No draft found.</div>;

  return (
    <div className="flex flex-col overflow-hidden w-full">
      <div className="w-full h-full overflow-hidden ">
        <div className="thin-scrollbar w-full flex-1 flex flex-col lg:flex-row gap-2 p-1 h-full overflow-auto">
          <div className={`lg:w-4/6 w-full p-2 h-full flex flex-col overflow-x-auto shadow-inner rounded-lg ${sidebarThemeClass}`}>
            <div className="mb-1.5">
              <CommonButtons className="shadow-sm border border-gray-300" label="BACK" onClick={() => navigate(-1)} variant="secondary" icon={KeyboardReturnIcon} />
              {/* <button
                onClick={() => navigate(-1)}
                className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#DDE2F5] text-[#1E2A4A] text-sm font-semibold hover:bg-[#CBD3F0] transition-colors mb-4"
              >
                <span aria-hidden>←</span> BACK
              </button> */}
            </div>

            <div className="flex-1 min-h-0 overflow-hidden">
              <ProductsTable products={draft.products} />
            </div>
          </div>
          <div className={`thin-scrollbar xl:w-4/12 lg:w-5/12 w-full h-full pr-1 flex flex-col flex-shrink-0 lg:overflow-y-auto lg:overflow-x-hidden shadow-inner rounded-lg p-1 ${sidebarThemeClass}`}>
            <OrderSummaryPanel
              draft={draft}
              onCancelOrder={() => {
                /* wire to your cancel-order API */
              }}
              onReviewOrder={() => setClosePopup(true)}
            />
          </div>
        </div>

        {closePopup && <ApprovalModal draft={draft} onClose={() => setClosePopup(false)} updatesLedgerLimit={updatesLedgerLimit} draftStatusUpdate={draftStatusUpdate} />}
      </div>
      <ToastContainer />
    </div>
  );
}

export default DraftDetails;
